<template>
    <div class="app-container">
      <BjPage ref="BjPage" :label-width="'80px'" :query-params="queryParams" :selection="selection" :col-span="colSpan" :get-action="queryApi" :before-reset-search="beforeResetSearch" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @afterFetchOriginalData="afterFetchOriginalData" @header-contextmenu="SortableTable.handleHeaderContextmenu">
        <template v-slot:baseForm>
          <el-col :span="colSpan">
            <el-form-item :label="$t('billingPage.zoneGroup')" prop="logisticsGroupName">
              <BjInput v-model="queryParams.logisticsGroupName" :placeholder="$t('billingPage.zoneGroup')" @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('billingPage.zoneGroupType')" prop="zoneGroupType">
              <BjSelectLov v-model="queryParams.zoneGroupType" :option-list="ZONE_GROUP_TYPE_LIST" :placeholder="$t('billingPage.zoneGroupType')" @change="handleQuery"/>
            </el-form-item>
          </el-col>
        </template>
  
        <template v-slot:tableOperation>
          <el-col>
            <el-button v-permission:USER-ONBOARDING-ADD type="primary" class="main-btn" @click="onAdd">{{ $t('createText') }}</el-button>
          </el-col>
        </template>
  
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
              <template slot-scope="scope">
                <template v-if="false" />
                <template v-else-if="col.prop === 'logisticsGroupName'">
                  <span class="link" @click="goDetail(scope.row)">{{ scope.row[col.prop]}}</span>
                  <BjCopyIcon :copy="scope.row[col.prop]" />
                </template>
                <template v-else-if="col.prop === 'zoneGroupType'">
                  {{ ZONE_GROUP_TYPE_LIST.bjGet(scope.row.zoneGroupType) }}
                </template>
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
              <template slot-scope="props">
                <el-button type="text" class="edit-btn" @click="onEdit(props.row)">{{ $t('editText') }}</el-button>
                <el-button type="text" class="edit-btn" @click="onCopy(props.row)">{{ $t('copyText') }}</el-button>
                <el-button type="text" class="delete-btn" @click="onDelete(props.row)">{{ $t('delText') }}</el-button>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
      <el-dialog :visible.sync="dialogVisible" width="500px" :before-close="handleClose">
        <el-form ref="form" :model="form" status-icon :rules="rules" label-position="top" label-width="100px">
          <el-form-item :label="$t('billingPage.zoneGroup')" prop="logisticsGroupName">
            <BjInput v-model="form.logisticsGroupName" :placeholder="$t('billingPage.zoneGroup')"/>
          </el-form-item>
          <el-form-item :label="$t('billingPage.zoneGroupType')" prop="zoneGroupType">
            <BjSelectLov v-model="form.zoneGroupType" :option-list="ZONE_GROUP_TYPE_LIST" :placeholder="$t('billingPage.zoneGroupType')"/>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="onConfirm()">{{ $t('okText') }}</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  
  <script>
    import pageMiXin from '@/utils/page-mixin.js';
    import { logisticApi } from '@/api';
  
    export default {
      name: 'BusinessLogisticsZoneIndex',
      mixins: [pageMiXin],
      data() {
        return {
          colSpan: 4,
          queryApi: logisticApi.getLogisticGroupList,
          queryParams: {
            zoneGroup: null,
            zoneGroupType: null,
          },
          labelList: [
            { label: this.$t('billingPage.zoneGroup'), prop: 'logisticsGroupName', isCheck: true, disabled: false, },
            { label: this.$t('billingPage.zoneGroupType'), prop: 'zoneGroupType', isCheck: true, disabled: false, },
            { label: this.$t('billingPage.Postcode'), prop: 'postCodeCount', isCheck: true, disabled: false, },
            { label: this.$t('billingPage.Updated'), prop: 'updatedName', isCheck: true, disabled: false, },
            { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 187 },
          ],
          dialogVisible:false,
          form:{
            logisticsGroupName:null,
            zoneGroupType:null,
          },
          ZONE_GROUP_TYPE_LIST: [
            { label: this.$t('billingPage.zoneGroupType1'), value: '1' },
            { label: this.$t('billingPage.zoneGroupType2'), value: '2' },
            { label: this.$t('billingPage.zoneGroupType3'), value: '3' },
          ],
        };
      },
      computed: {
        rules() {
          const rules = {
            logisticsGroupName: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
            zoneGroupType: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
          };
          return rules;
        },
      },
      methods: {
        onAdd() {
          this.form.openType = 'add'
          this.dialogVisible = true
        },
        goDetail(row) {
          this.$router.push({
            name: 'BusinessLogisticsZoneDetail',
            query: { id: row.id},
          });
        },
        onEdit(row) {
          this.form = JSON.parse(JSON.stringify(row))
          this.form.openType = 'edit'
          this.dialogVisible = true
        },
        onCopy(row) {
          this.form = JSON.parse(JSON.stringify(row))
          this.form.openType = 'copy'
          this.dialogVisible = true
        },
        handleClose(){
          this.form={ logisticsGroupName:null }
          this.$refs['form'].resetFields();
          this.dialogVisible = false
        },
        onConfirm(){
          this.$refs.form.validate((valid) => {
            if(valid){
              if(this.form.openType=='copy'){
                // 复制
                const POST_DATA = this.form
                logisticApi.copyLogisticGroupList(POST_DATA).then(res=>{
                  if(!res.failed){
                    this.$message.success(this.$t('toast.operationSuccessText'));
                    setTimeout(() => {
                      this.handleClose()
                      this.reFresh();
                    }, 500);
                  }
                })
              }else if(this.form.openType=='edit'){
              // 编辑
              const POST_DATA = this.form
                logisticApi.updateLogisticGroupList(POST_DATA).then(res=>{
                  if(!res.failed){
                    this.$message.success(this.$t('toast.operationSuccessText'));
                    setTimeout(() => {
                      this.handleClose()
                      this.reFresh();
                    }, 500);
                  }
                })
              }else{
                // 新增
                logisticApi.addLogisticGroupList(this.form).then(res=>{
                  if(!res.failed){
                    this.$message.success(this.$t('toast.operationSuccessText'));
                    setTimeout(() => {
                      this.handleClose()
                      this.reFresh();
                    }, 500);
                  }
                })
              }
            }
          })
        },
        onDelete(row) {
          this.$confirm(this.$t('InternalSalesOrderDetails.want'), this.$t('toast.hintText'), {
            confirmButtonText: this.$t('toast.okText'),
            cancelButtonText: this.$t('toast.cancelText'),
            type: 'warning',
          })
            .then(() => {
              logisticApi.delLogisticGroupList({ids:[row.id]}).then(res => {
                if (!res.failed) {
                  this.$message.success(this.$t('toast.operationSuccessText'));
                  setTimeout(() => {
                    this.reFresh();
                  }, 500);
                }
              });
            })
            .catch(() => {});
        },
  
        beforeResetSearch() {
          this.queryParams.zoneGroup = null;
          return new Promise(resolve => {
            resolve();
          });
        },
      },
    };
  </script>
  <style lang="scss" scoped>
  ::v-deep .bj-page .el-form-item__label {
    display: none;
  }
  .el-icon-s-flag {
    float: right;
    line-height: 34px;
  }
  </style>
  